import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { SetupService } from './setup.service';
import { ObjectNames, MenuItems } from '../constants/constants';
import { AccountService } from 'src/app/configurations/finance/finance-setup/account/account.service';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.scss']
})
export class SetupComponent implements OnInit {

  configMenuSetupItems: any[];
  index: number = 0;
  cachedIndex: number = null;  // Track which index was rendered
  inventorygrps: any = [];
  discountTypes: any = [];
  coregrps: any = [];
  financialAccounts = [];
  navFixed: boolean = false;
  baseCurrency: any;
  private scrollOffset: number = 70;
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  //payment method
  displayPaymentMethodAdd: boolean = false;
  displayPaymentTermAdd: boolean = false;


  constructor(private setupService: SetupService, private financeService: AccountService, private importService: ImportserialService,) { }

  ngOnInit(): void {
    this.getBaseCurrency();
    this.getAllInvGroups();
    this.loadAccountList();
    this.configMenuSetupItems = [
      {
        label: MenuItems.PaymentTerm,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddPaymentTerm();
        }
      },
      {
        label: MenuItems.PaymentMethods,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddPaymentMethod();
        }
      },
      {
        label: MenuItems.VendorPaymentTerm,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddVendorPaymentTerm();
        }
      },
      {
        label: MenuItems.VendorPaymentMethods,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddVendorPaymentMethod();
        }
      },
      {
        label: MenuItems.ShippingMethods,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddShippingMethod();
        }
      },
      {
        label: MenuItems.ShippingTerms,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddShippingTerm();
        }
      },
      {
        label: MenuItems.FOB,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddFOB();
        }
      },
      {
        label: MenuItems.Discount,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddDiscount();
        }
      },
      {
        label: MenuItems.AdditionalFees,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddAddtionalFees();
        }
      },
      {
        label: MenuItems.TaxCountry,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddRate();
        }
      },
      {
        label: MenuItems.Order,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddOrderSource();
        }
      },
      {
        label: MenuItems.Uom,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddUom();
        }
      },
      {
        label: MenuItems.PackBox,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddPackBox();
        }
      },
      // {
      //   label: MenuItems.TaxCountry,
      //   icon: 'pi pi-plus',
      //   command: () => {
      //     this.showAddRate();
      //   }
      // },
    ];
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    this.navFixed = (window.pageYOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop || 0
    ) > this.scrollOffset;
  }

  getAllInvGroups() {
    this.setupService.getAllInventoryGroups().subscribe((groups) => {
      this.inventorygrps = groups;
      const discountGroup = this.inventorygrps.find(group => group.name == ObjectNames.setupConstants.Discount_Name);
      this.getAllDiscountTypes(discountGroup?.id);
    })
  }

  getAllDiscountTypes(id) {
    this.setupService.getAllDiscountTypes(id).subscribe((types) => {
      this.discountTypes = types;
    })
  }

  getAllCoreGroups() {
    this.setupService.getAllInventoryGroups().subscribe((groups) => {
      this.coregrps = groups;
    })
  }

  getIndex(event) {
    this.index = event.index;
    this.displayPaymentMethodAdd = false;
    this.displayPaymentTermAdd = false;
    this.cachedIndex = event.index;
  }

  showAddPaymentTerm() {
    this.index = 0;
    this.displayPaymentTermAdd = true;
  }

  showAddPaymentMethod() {
    this.index = 1;
    this.displayPaymentMethodAdd = true;
  }

  closePaymentMethod() {
    this.displayPaymentMethodAdd = false;
  }

  closePaymentTerm() {
    this.displayPaymentTermAdd = false;
  }

  showAddVendorPaymentTerm() {
    this.displayPaymentTermAdd = true;
    this.index = 2;
  }

  showAddVendorPaymentMethod() {
    this.index = 3;
    this.displayPaymentMethodAdd = true;
  }

  showAddOrderSource() {
    this.index = 10;
    this.setupService.setOrderSource(ObjectNames.BehaviorSubjectVariable);
  }

  showAddRate() {
    this.index = 9;
    this.setupService.setTax(ObjectNames.BehaviorSubjectVariable);
  }

  showAddDiscount() {
    this.index = 7;
    this.setupService.setDiscount(ObjectNames.BehaviorSubjectVariable);
  }

  showAddAddtionalFees() {
    this.index = 8;
    this.setupService.setAdditionalFee(ObjectNames.BehaviorSubjectVariable);
  }

  showAddFOB() {
    this.index = 6;
    this.setupService.setFOB(ObjectNames.BehaviorSubjectVariable);
  }

  showAddShippingMethod() {
    this.index = 4;
    this.setupService.setShippingMethod(ObjectNames.BehaviorSubjectVariable);
  }

  showAddShippingTerm() {
    this.index = 5;
    this.setupService.setShippingTerm(ObjectNames.BehaviorSubjectVariable);
  }

  showAddUom() {
    this.index = 11;
    this.setupService.setUom(ObjectNames.BehaviorSubjectVariable);
  }

  showAddPackBox() {
    this.index = 12;
    this.setupService.setPackBox(ObjectNames.BehaviorSubjectVariable);
  }

  loadAllFinancialAccounts() {
    this.setupService.getAllFinancialAccounts().subscribe(accounts => {
      this.financialAccounts = accounts;
    })
  }
  transformFinancialAccounts(accounts: any[]): any[] {
    return accounts.map(account => {
      return {
        ...account,
        labelName: `${account.value.name}`,
        label: `${account.value.displayNumber || ""} - ${account.value.name}`,
        children: account.children && account.children.length > 0
          ? this.transformFinancialAccounts(account.children)
          : []
      };
    });
  }
  loadAccountList() {
    this.financeService.getAllAccounts().subscribe((accounts) => {
      let data = [];
      for (let c of accounts) {
        let ChildData = [];
        for (let s of c.childAccounts) {
          let subData = [];
          for (let subb of s.childAccounts) {
            // Fourth Level Data
            let subbData = [];
            for (let subbLevl of subb.childAccounts) {
              let fourthLevelData = [];
              for (let fourthLevel of subbLevl.childAccounts) {
                let eachFourthLevel = {
                  label: fourthLevel.name,
                  value: fourthLevel,
                  children: []
                };
                fourthLevelData.push(eachFourthLevel);
              }

              let eachSubb = {
                label: subbLevl.name,
                value: subbLevl,
                children: fourthLevelData, // Assign fourth-level children
              };
              subbData.push(eachSubb);
            }

            let eachSub = {
              label: subb.name,
              value: subb,
              children: subbData, // Third level children
            };
            subData.push(eachSub);
          }

          let eachSub = {
            label: s.name,
            value: s,
            children: subData // Second level children
          };
          ChildData.push(eachSub);
        }

        let eachData = {
          label: c.name,
          inactiveStatus: true,
          value: c,
          children: ChildData // First level children
        };
        data.push(eachData);
      }
      this.financialAccounts = this.transformFinancialAccounts(data);
    });
  }

  getBaseCurrency() {
    this.importService.getOrgCurrency().pipe(takeUntil(this.ngUnsubscribe$)).subscribe((value) => {
      if (value) {
        this.baseCurrency = value?.find((cr) => cr.isBaseCurrency);
      }
    });
  }
  
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
